var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{attrs:{"database":_vm.database,"table":_vm.table,"fields":_vm.fields,"views":_vm.views,"view":_vm.view,"table-loading":_vm.tableLoading,"read-only":true,"disable-filter":true,"disable-sort":true,"disable-group-by":true,"store-prefix":"template/"},on:{"selected-view":function($event){return _vm.selectView({ viewId: $event.id })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }